


































































import { Vue, Component } from "vue-property-decorator";
import Address from "@/zh-website/src/components/website/Address.vue";
import ReadTo from "@/zh-website/src/views/partner/supplier/ReadTo.vue";
import { PubBiddingService } from "@/zh-website/src/views/partner/service/pubBidding";
import { RecruitService } from "@/zh-website/src/views/Recruit/service";
import { RegService } from "@common/service/base-service/reg";
import Vcode from "@common/components/puzzle-vcode";
import { ICTLoginService } from "@common/ict/service/data-service/login";

@Component({
  components: {
    Address,
    ReadTo,
    Vcode
  }
})
export default class PubBiddingRegister extends Vue {

  imgs = [
    require("@common/assets/slider-1.png"),
    require("@common/assets/slider-2.png"),
    require("@common/assets/slider-3.png"),
    require("@common/assets/slider-4.png")
  ];
  fgImg = "";
  fgY = 0;
  fgX = 0;
  VCID = "";
  isShowSlider = false;
  isSliderSuccess = false;

  timer: any = null;
  countDown = 0;
  isCheck = false;
  isSuccess = false;
  isExpired = false;

  applyForm = {
    companyName: "",
    contactName: "",
    email: "",
    contactPhone: "",
    code: ""
  };

  applyRules = {
    companyName: [
      {
        required: true,
        message: "请填写公司名称",
        trigger: ["change", "blur"]
      }
    ],
    contactName: [
      {
        required: true,
        message: "请填写联系人姓名",
        trigger: ["change", "blur"]
      }
    ],
    email: [
      {
        required: true,
        message: "请填写邮箱",
        trigger: ["change", "blur"]
      },
      {
        pattern: RegService.EMAIL, 
        message: "邮件格式错误"
      }
    ],
    contactPhone: [
      {
        required: true,
        message: "请填写联系人手机号",
        trigger: ["change", "blur"]
      },
      {
        pattern: RegService.PHONE, 
        message: "手机号格式错误"
      }
    ],
    code: [
      {
        required: true,
        message: "请填写验证码",
        trigger: ["change", "blur"]
      }
    ]
  };

  mounted() {
    PubBiddingService.getPubBiddingDetailFull({pubBiddingId: this.$route.params.aid}).then((res: any) => {
      if (res.success) {
        this.isExpired = res.data.isExpired;
      } else {
        this.$message.error(res.message);
      }
    });
  }

  submitPubBiddingApply() {
    console.log("submit pub bidding apply");
    (this.$refs['applyForm'] as any).validate(valid => {
        if (valid) {
          if (!this.isCheck) {
            this.$message.error("请仔细阅读并同意隐私协议");
            return false;
          }
          const params = Object.assign(this.applyForm, {signStatus: true, pubBiddingId: this.$route.params.aid});
          PubBiddingService.submitPubBiddingApply(params).then((res: any) => {
            if (res.success) {
              this.isSuccess = true;
              this.applyForm = {
                companyName: "",
                contactName: "",
                email: "",
                contactPhone: "",
                code: ""
              };
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
            return false;
        }
    });
  }

  // 滑块验证失败
  failSliderLogin(err) {
    this.$message.warning("滑块验证失败");
    this.closeSliderLogin();
  }

  async checkVerifyCode({ x, y }) {
    this.fgX = x;
    return ICTLoginService.checkSliderRes({
      verificationCodeId: this.VCID,
      isDeleteAfterSuccess: false,
      x,
      y
    }).then((res: any) => {
      if (!res) {
        throw new Error();
      }
      return res;
    });
  }
  successSliderLogin(res) {
    if (res) {
      this.isSliderSuccess = true;
      this.getCode();
    }
  }

  getSlideInfo() {
    ICTLoginService.getVerifyCode().then(res => {
      if (res) {
        this.imgs = [res.shadeImage];
        this.fgImg = res.cutoutImage;
        this.fgY = res.y;
        this.VCID = res.verificationCodeId;
        // 显示登录右滑拼图验证
        this.isShowSlider = true;
      }
    });
  }

  closeSliderLogin() {
    this.isShowSlider = false;
    this.isSliderSuccess = false;
  }

  getCode() {
    console.log("getCode");
    (this.$refs["applyForm"] as any).validateField("contactPhone", err => {
      if (!err && !this.timer) {
        if (!this.isSliderSuccess) {
          this.getSlideInfo();
        } else {
          this.closeSliderLogin();
          const params = {
            phone: this.applyForm.contactPhone,
            verificationCodeId: this.VCID,
            y: this.fgY,
            x: this.fgX
          }
          RecruitService.getCode(params).then(() => {
            this.countDown = 60;
            this.timer = setInterval(() => {
              this.countDown--;
              if (this.countDown <= 0) {
                  clearInterval(this.timer);
                  this.timer = null;
                  this.countDown = 0;
              }
            }, 1000);
          });
        }
      }
    });
  }
}
